import { mutationTypes, actionTypes } from '../access-keys'
import defaultStates from './appointment/default-states'
import { map } from '../helpers/mapper'

export default {
  namespaced: true,
  state: defaultStates.forRoot(),
  getters: {},
  mutations: {
    [mutationTypes.appointment.RESET_STATE](state) {
      map(defaultStates.forRoot(), state)
    },
    [mutationTypes.appointment.ACTIVATE_STEP](state, step) {
      if (step > state.stepActiveTo) {
        state.stepActiveTo = step
      }
    },
    [mutationTypes.appointment.UNACTIVATE_STEP](state, step) {
      if (step < state.stepActiveTo) {
        state.stepActiveTo = step
      }
    }
  },
  actions: {
    [actionTypes.appointment.RESET_FORM]({ commit }) {
      commit(mutationTypes.appointment.RESET_STATE)
      commit(mutationTypes.appointment.step1.RESET_STATE_ROOT, null, { root: true })
      commit(mutationTypes.appointment.step2.RESET_STATE_ROOT, null, { root: true })
      // commit(mutationTypes.appointment.step3.RESET_STATE_ROOT, null, { root: true })
    }
  },
  modules: {
    step1: {
      namespaced: true,
      state: defaultStates.forStep1(),
      getters: {},
      mutations: {
        [mutationTypes.appointment.step1.RESET_STATE](state) {
          map(defaultStates.forStep1(), state)
        },
        [mutationTypes.appointment.step1.REGISTER_FORM_DATAS](state, payload) {
          state.formDatas = payload
          state.isValidated = true
        }
      },
      actions: {
        [actionTypes.appointment.step1.COMPLETE_STEP]({ commit, state }, payload) {
          commit(mutationTypes.appointment.step1.REGISTER_FORM_DATAS, payload)
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.appointment.ACTIVATE_STEP_ROOT, 2, { root: true })
          commit(mutationTypes.appointment.step3.RESET_STATE_ROOT, null, { root: true })
        }
      }
    },
    step2: {
      namespaced: true,
      state: defaultStates.forStep2(),
      getters: {},
      mutations: {
        [mutationTypes.appointment.step2.RESET_STATE](state) {
          map(defaultStates.forStep2(), state)
        },
        [mutationTypes.appointment.step2.REGISTER_FORM_DATAS](state, payload) {
          state.formDatas = payload
          state.isValidated = true
        }
      },
      actions: {
        [actionTypes.appointment.step2.COMPLETE_STEP]({ commit, state }, payload) {
          commit(mutationTypes.appointment.step2.REGISTER_FORM_DATAS, payload)
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.appointment.ACTIVATE_STEP_ROOT, 3, { root: true })
        },
        [actionTypes.appointment.step2.RESET_STEP]({ commit, state }) {
          commit(mutationTypes.appointment.step2.RESET_STATE)
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.appointment.UNACTIVATE_STEP_ROOT, 2, { root: true })
        }
      }
    },
    step3: {
      namespaced: true,
      state: defaultStates.forStep3(),
      getters: {},
      mutations: {
        [mutationTypes.appointment.step3.RESET_STATE](state) {
          map(defaultStates.forStep3(), state)
        },
        [mutationTypes.appointment.step3.REGISTER_APPOINTMENT_RESPONSE](state, payload) {
          state.appointmentResponse = payload
        }
      },
      actions: {}
    }
  }
}
